import qs from "qs";
import { getStore, getUrlRelativePath, clearUserInStore, getTimezoneName, getMobileOperatingSystem} from "./mUtils";

const baseUrl = process.env.VUE_APP_BASE_API;
const baseCDNUrl = process.env.VUE_APP_BASE_CDN_API;

let requestUrlTicksData = {};

//<param name="urlType">1-BaseUrl, 2-CDNUrl, 0-ExternalUrl</param>
export default async (url = '', data = {}, type = 'GET', method = 'fetch', token = '', isFile = false, isMonitorLast = false, urlType = 1) => {
	//var baseUrl = process.env.API_ROOT
	type = type.toUpperCase();
	switch (urlType) {
		case 1:
			url = baseUrl + url;
			break;
		case 2:
			url = baseCDNUrl + url;
			break;
	}
	
	let timezone = getTimezoneName();
	let device = getMobileOperatingSystem();
	if (type == 'GET') {
		let dataStr = qs.stringify(data, {arrayFormat: 'repeat'});
		
		//数据拼接字符串
		// Object.keys(data).forEach(key => {
		// 	let value = data[key] !== undefined && data[key] !== null ? data[key] : '';
		// 	let valueType = Object.prototype.toString.call(value).match(/^\[object\s(.*)\]$/)[1].toLowerCase();

		// 	if (valueType === "array") {
		// 		value.forEach(item => {
		// 			dataStr += `${key}=${item}&`;
		// 		});
		// 		return;
		// 	}

		// 	if (valueType === "number" && isNaN(value))
		// 		value = '';

		// 	dataStr += `${key}=${value}&`;
		// })

		if (!!dataStr) {
			// dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
			url = `${url}?${dataStr}`;
		}
	}


	if (window.fetch && method == 'fetch') {
		let requestConfig = {
			//credentials: 'include',
			method: type,
			headers: {
				//'Accept': 'application/json',
				'Content-Type': 'application/json',
				"Access-Control-Allow-Origin": "*",
				"Access-Control-Allow-Headers": "*",
				'Access-Control-Expose-Headers': "*",
				"pragma":"no-cache",
				"cache-control":"no-cache",
				"timezone":timezone,
				"device": device
			},
			mode: "cors",
			//cache: "force-cache"
		};
		if (urlType === 0) {
			requestConfig.headers = new Headers({
				'Origin': location.origin
			});
		}
		if (!!token) {
			requestConfig.headers['Authorization'] = 'Bearer ' + token;
		}
		if (type == 'POST') {
			Object.defineProperty(requestConfig, 'body', {
				value: JSON.stringify(data)
			})
		}

		if (isMonitorLast){
			let ticks = new Date().getTime();
			requestUrlTicksData[url] = {ticks: ticks};
			let ticksPara = "ticks=" + ticks.toString();
			if (url.indexOf("?") < 0){
				url += "?" + ticksPara;
			}else{
				url += "&" + ticksPara;
			}
		}

		try {
			// console.log("fetch: ", url, requestConfig);
			return await fetch(url, requestConfig).then((response) => {
				if (isMonitorLast && !!requestUrlTicksData){
					let responseUrl = response.url;
					let index = responseUrl.indexOf("ticks=");
					let currentTicks = parseInt(responseUrl.substring(index + 6));
					let originalUrl = responseUrl.substring(0, index);
					if (originalUrl.substring(originalUrl.length - 1) == "?"){
						originalUrl = originalUrl.substring(0, originalUrl.length - 1);
					}
					if (!!requestUrlTicksData[originalUrl]){
						let lastTicks = requestUrlTicksData[originalUrl].ticks;

						if (currentTicks < lastTicks){
							return; //{ success: false, message: 'A new request was started.'};
						}
					}
				}
				if (response.status == 200) {
					if (isFile){
						let filename = "";
						let disposition = response.headers.get('Content-Disposition');
						if (!disposition){
							disposition = response.headers['Content-Disposition'];
						}
						
						if (!!disposition && disposition.indexOf('attachment') !== -1) {
							var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
							var matches = filenameRegex.exec(disposition);
							if (matches != null && matches[1]) { 
								filename = matches[1].replace(/['"]/g, '');
							}
						}
						
						//let filename = (response.headers['Content-Disposition'] || '').split('filename=')[1];
						return response.blob().then((responseJson) => {
							return { success: true, data: responseJson, filename:filename };
						});
					}else{
						return response.json().then((responseJson) => {
							return { success: true, data: responseJson };
						});
					}
				} else if (response.status == 400) {
					//let msg = responseJson.message;
					//return { success: false, message: msg };
					return response.json().then((responseJson) => {
						let msg = '';
						let statusCode = '';
						let exceptionType = 0;
						if (!!responseJson) {
							msg = responseJson.Message;
							statusCode = responseJson.StatusCode;
							exceptionType = responseJson.ExceptionType;
						}

						return { success: false, message: msg, statusCode: statusCode, exceptionType: exceptionType};
					});
				} else if (response.status == 401) {
					let role = getStore('user_role');
					let path = getUrlRelativePath(window.location.href);
					
					if (path != '/admin/' && path != '/admin' && path != '/') {
						clearUserInStore();
						if (role == '1') {
							window.location.href = "/admin/";
						} else {
							window.location.href = "/";
						}
					}
				} else if (response.status == 403) {
					return { success: false, message: '您无权进行此操作' };
				} else {
					return { success: false, message: '' };
				}
			})
				.catch((err) => {
					throw new Error(err)
				});
			//const response = await fetch(url, requestConfig);
			//const responseJson = await response.json();

		} catch (error) {
			throw new Error(error)
		}
	} else {
		return new Promise((resolve, reject) => {
			let requestObj;
			if (window.XMLHttpRequest) {
				requestObj = new XMLHttpRequest();
			} else {
				requestObj = new ActiveXObject;
			}

			let sendData = '';
			if (type == 'POST') {
				sendData = JSON.stringify(data);
			}

			requestObj.open(type, url, true);
			requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			requestObj.setRequestHeader("timezone", timezone);
			if (!!token) {
				requestObj.setRequestHeader('Authorization', 'Bearer ' + token);
			}
			requestObj.send(sendData);

			requestObj.onreadystatechange = () => {

				if (requestObj.readyState == 4) {
					if (requestObj.status == 200) {
						let obj = requestObj.response
						if (typeof obj !== 'object') {
							obj = JSON.parse(obj);
						}
						resolve(obj);
					} else {
						reject(requestObj);
					}
				}
			}
		})
	}
}



// WEBPACK FOOTER //
// ./src/config/fetch.js